import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=c313b730&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=c313b730&prod&lang=scss"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=c313b730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c313b730",
  null
  
)

export default component.exports